import { render } from "./WiseInfocard.vue?vue&type=template&id=62910ce6"
import script from "./WiseInfocard.vue?vue&type=script&lang=js"
export * from "./WiseInfocard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__